import React from 'react'
import ReactEcharts from 'echarts-for-react';
import * as echarts from "echarts";

export default function StackedBarChart({ tooltip, grid, legend, xAxisData, yAxisData, series }) {
    const defaultTooltip = {
        trigger: 'axis',
        backgroundColor: 'rgba(50,50,50,0.7)',
        borderColor: "#333",
        textStyle: {
            fontSize: 12,
            fontWeight: "normal",
            color: '#fff',
        },
        axisPointer: {
            type: 'shadow'
        },
        confine: true,
        valueFormatter: (value) => value?.toFixed(1) + '%',
    }
    const option = {
        tooltip: tooltip ? tooltip : defaultTooltip,
        legend: legend,
        grid: grid,
        xAxis: xAxisData,
        yAxis: yAxisData,
        series: series
    };

     return (
         <ReactEcharts
            option={option}
            opts={{renderer:'svg'}}
            style={{ width: '100%', height: '100%' }}
        />
      )
}